import React from 'react';
import { Card, CardBody, Button } from 'reactstrap';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('system_configuration');

interface ConfigSidebarProps {
  companyName: string;
  companyLogo?: string;
  // Mục 8bis (README §8) — 3 tab Hoa hồng / Giá vé / Ngưỡng thuế TNCN đã gộp vào "Profile Vùng miền".
  activeTab: 'region' | 'lookup';
  onTabChange: (tab: 'region' | 'lookup') => void;
}

const ConfigSidebar: React.FC<ConfigSidebarProps> = ({
  companyName,
  companyLogo,
  activeTab,
  onTabChange,
}) => {
  return (
    <Card>
      <CardBody className="text-center p-4">
        <div className="position-relative d-inline-block mb-3">
          <div
            className="avatar-xl rounded border border-2 border-primary overflow-hidden mx-auto"
            style={{ width: '100px', height: '100px' }}
          >
            {companyLogo ? (
              <img
                src={companyLogo}
                alt={companyName}
                className="img-fluid"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  padding: '10px'
                }}
              />
            ) : (
              <div className="d-flex align-items-center justify-content-center h-100 bg-primary-subtle">
                <i
                  className="ri-building-4-line text-primary"
                  style={{ fontSize: '48px' }}
                ></i>
              </div>
            )}
          </div>
        </div>

        <h5 className="mb-1">{companyName}</h5>
        <p className="text-muted mb-2" style={{ fontSize: '13px' }}>
          {st('cau_hinh_he_thong_text')}
        </p>

        <hr className="my-3" />

        {/* Action Buttons */}
        <div className="d-grid gap-2">
          <Button
            color="primary"
            outline
            onClick={() => onTabChange('region')}
            active={activeTab === 'region'}
          >
            <i className="ri-map-pin-line me-1"></i>
            {st('profile_vung_mien_button')}
          </Button>
          <Button
            color="primary"
            outline
            onClick={() => onTabChange('lookup')}
            active={activeTab === 'lookup'}
          >
            <i className="ri-search-line me-1"></i>
            {st('duong_dan_button')}
          </Button>
        </div>
      </CardBody>
    </Card>
  );
};

export default ConfigSidebar;
